import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

function getCategoryName(slug: string): string {
  return categories.find((c) => c.slug === slug)?.name || slug;
}

export default function FeaturedContent() {
  const featured = articles.slice(4, 8);

  return (
    <section className="py-14 md:py-18 px-4 md:px-6">
      <div className="mx-auto max-w-6xl">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精选内容
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            编辑精选的优质内容，覆盖热门话题与深度分析
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex flex-col sm:flex-row gap-4 bg-background-50 border border-background-200/70 rounded-lg p-4 hover:border-background-300/80 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full sm:w-48 h-32 flex-shrink-0 rounded-md overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  title={article.title}
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 whitespace-nowrap">
                    {getCategoryName(article.category)}
                  </span>
                  <span className="text-xs text-foreground-500">{article.publishDate}</span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 mb-1.5 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.summary}
                </p>
                <div className="mt-2 flex items-center gap-1.5">
                  <span className="text-xs text-foreground-500">{article.author}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}